import { useTranslation } from 'react-i18next';

import { ResetAction } from '@/shared/types/action';

const Reset = ({ action }: { action: ResetAction }) => {
  const { t } = useTranslation();
  const { variables = [] } = action;

  return (
    <span className="text-sm leading-5 font-normal text-muted-foreground">
      {variables.length > 0
        ? t('dialog.variables', { 0: variables.length, count: variables.length })
        : t('dialog.all_variables')}
    </span>
  );
};

export default Reset;
